import { Action } from "@ngrx/store";

import { DocumentState, Signature } from "./state";
import * as Actions from "./actions";
import * as ModelActions from "../model/actions";
import { updateArrayAt } from "../../utils/utils";

export function documentReducer(
    state: DocumentState = new DocumentState(),
    action: Actions.Actions | ModelActions.Actions,
) {
    switch (action.type) {
        case Actions.Update.type: {
            const diff = {};
            action.updates.forEach(([key, value]) => {
                diff[key] = value;
            });
            return Object.assign({}, state, diff);
        }

        case Actions.SetSignature.type: {
            const signature = state.signatures[action.index];
            const newSignature = Object.assign({}, signature, {
                dataUrl: action.dataUrl,
            });
            const newState = Object.assign({}, state, {
                signatures: updateArrayAt(
                    state.signatures,
                    action.index,
                    newSignature,
                ),
            });
            return newState;
        }

        case ModelActions.AddAction.type:
        case ModelActions.DeleteAction.type:
        case ModelActions.MergeAction.type:
        case ModelActions.UpdateAction.type:
            return Object.assign({}, state, { dirty: true });

        case ModelActions.ReplaceDatabaseAction.type:
            return Object.assign({}, state, new DocumentState());

        default:
            return state;
    }
}
